import type { ReactNode } from 'react';

export const symbol_business_chip: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M360-320h240q17 0 28.5-11.5T640-360v-160q0-17-11.5-28.5T600-560h-40v-45q0-14-10.5-24.5T525-640h-90q-14 0-24.5 10.5T400-605v45h-40q-17 0-28.5 11.5T320-520v160q0 17 11.5 28.5T360-320Zm75-240v-45h90v45h-90ZM320-200q-117 0-198.5-81.5T40-480q0-117 81.5-198.5T320-760h320q117 0 198.5 81.5T920-480q0 117-81.5 198.5T640-200H320Zm0-60h320q91 0 155.5-64.5T860-480q0-91-64.5-155.5T640-700H320q-91 0-155.5 64.5T100-480q0 91 64.5 155.5T320-260Zm160-220Z"
		/>
	</svg>
);
